module.exports = __webpack_public_path__ + "static/media/slidingBottomImg3.e61b5362.png";